// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__L3tT2","employee-header-item":"Header_employee-header-item__hobIw"};